import React from 'react';
import { Tooltip, Chip, Box } from '@mui/material';
import { 
  LockOutlined as LockedIcon, 
  LockOpenOutlined as UnlockedIcon,
  Security as SecurityIcon
} from '@mui/icons-material';

interface EncryptionBadgeProps {
  isEncrypted: boolean;
  size?: 'small' | 'medium';
  showLabel?: boolean;
}

const EncryptionBadge: React.FC<EncryptionBadgeProps> = ({ 
  isEncrypted, 
  size = 'small',
  showLabel = true
}) => {
  if (isEncrypted) {
    return (
      <Tooltip title="This document is encrypted with AES-256 encryption">
        <Chip
          icon={<LockedIcon fontSize={size} />}
          label={showLabel ? "Encrypted" : ""}
          color="success"
          size={size}
          variant="outlined"
          sx={{ 
            fontWeight: 500,
            '& .MuiChip-icon': { 
              color: 'success.main',
              mr: showLabel ? undefined : 0
            }
          }}
        />
      </Tooltip>
    );
  } else {
    return (
      <Tooltip title="This document is not encrypted">
        <Chip
          icon={<UnlockedIcon fontSize={size} />}
          label={showLabel ? "Not Encrypted" : ""}
          color="warning"
          size={size}
          variant="outlined"
          sx={{ 
            fontWeight: 500,
            '& .MuiChip-icon': { 
              color: 'warning.main',
              mr: showLabel ? undefined : 0
            }
          }}
        />
      </Tooltip>
    );
  }
};

export default EncryptionBadge; 